const NothingDeclined = 0;
const PartialDeclined = 1;
const FullyDeclined = 2;

export default {
	NothingDeclined,
	PartialDeclined,
	FullyDeclined,
};
